(ns ycweb.app.admin.finance.closedycs.closedycs
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.grid :as grid]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.app.admin.finance.common :as fincommon]
   [ycweb.components.transitions :as t]
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])))

(def closed-ycs-table-config
  {:table-name :admin.closedycs/table-closed-ycs
   :row-id :id
   :data-source
   {:cursor [:admin.closedycs :updated-closed-ycs]}
   :options
   {:order :desc
    :sort-title "Date Added"
    :sticky-header? true
    :paging? true
    :pagination {:page 0 :page-size 250}}

   :column-defs
   [{:key :id
     :title "ID"}
    {:key :uuid
     :title "uuid"}
    {:key :supplierid
     :title "Supplier ID"}
    {:key :update_ts
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Updated Time tamp"}
    {:key :dateadded
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Date Added"}
    {:key :parentid
     :title "Parent ID"}
    {:key :ourref
     :title "Our Ref"}
    {:key :ournotes
     :title "Our Notes"}
    {:key :latestnotes
     :title "Latest Notes"}
    {:key :sentto
     :title "Sent To"}
    {:key :dateprereceived
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Date Prereceived"}
    {:key :datereceived
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Date Received"}
    {:key :originaldateexpected
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Original Date Expected"}
    {:key :dateexpected
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Date Expected"}
    {:key :datearrived
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Date Arrived"}
    {:key :supplierdate
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Supplier Date"}
    {:key :datedue
     :type :date
     :dateformat "dd/MM/yyyy"
     :title "Date Due"}
    {:key :message
     :title "Message"}
    {:key :deliverycost
     :title "Delivery Cost"}
    {:key :supplierref
     :title "Supplier Ref"}
    {:key :suppliercost
     :title "Supplier Cost"}
    {:key :calcvat
     :title "Calcvat"}
    {:key :transactiontype
     :title "Transaction Type"}
    {:key :invoicecaptured
     :title "Invoice Captured"
     :type :date
     :dateformat "dd/MM/yyyy"}
    {:key :externalinvoiceref
     :title "External Invoice Ref"}
    {:key :externalinvoiceid
     :title "External Invoice ID"}]})

(defmethod comms/receive :admin.closedycs/download-csv [app-atom {:keys [success data]}]
  (cond
    (not success)
    (toaster/open-toast app-atom :error "CSV failed to generate" {})

    :else
    (do
      (fincommon/download-as-csv data "closed-ycs")
      (toaster/open-toast app-atom :success "CSV generated, Downloading now." {}))))

(defmethod grid/action :admin.closedycs/button-download-csv [app-atom {:keys [csv]} _]
  (toaster/open-overlay app-atom :admin.closedycs/submit-dates)
  (comms/send :admin.closedycs/download-csv {:csv csv}))

(defmethod comms/receive :admin.closedycs/list-closed-ycs [app-atom {:keys [updated-closed-ycs]}]
  (toaster/close-overlay app-atom :admin.closedycs/submit-dates)
  (swap! app-atom update :admin.closedycs
    (fn [process]
      (assoc process
        :updated-closed-ycs (u/index-by :id updated-closed-ycs)
        :csv updated-closed-ycs
        :updated-closed-ycs-count (count updated-closed-ycs)))))

(defmethod grid/action :admin.closedycs/submit-dates [app-atom _ _]
  (toaster/open-overlay app-atom :admin.closedycs/submit-dates)
  (let [process-atom (cmn/process-cursor app-atom)
        {month :closed-ycs/month
         year :closed-ycs/year} @process-atom]
    (cond
      (nil? month)
      (toaster/open-toast app-atom :error "Please select a month" {})

      (nil? year)
      (toaster/open-toast app-atom :error "Please select a year" {})

      :else
      (comms/send :admin.closedycs/list-closed-ycs {:month month :year year}))))

(rum/defc closed-ycs < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        counted-ycs (cmn/curact process-atom :updated-closed-ycs-count)
        csv (cmn/curact process-atom :csv)
        current-year (dt/year (dt/now))]
    [:<>
     [:div.admin-react-wrapper__content
      (headings/heading "Closed off YCS's" {:type :h1 :size :large})]

     [:form.form.u-max-width-640.u-margin-bottom-40
      (headings/heading "Select month to view:" {:type :h3 :size :tiny })
      [:div.form-field
       [:div
        {:class (u/bem :flex-grid-group [:flush-force :align-left])}
        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          [:label.form-label
           "Month:"]
          (forms/select-raw
            (rum/cursor process-atom :closed-ycs/month)
            [{:value 0 :text "- Select Month -"}
             {:value 1 :text "January"}
             {:value 2 :text "February"}
             {:value 3 :text "March"}
             {:value 4 :text "April"}
             {:value 5 :text "May"}
             {:value 6 :text "June"}
             {:value 7 :text "July"}
             {:value 8 :text "August"}
             {:value 9 :text "September"}
             {:value 10 :text "October"}
             {:value 11 :text "November"}
             {:value 12 :text "December"}])]]
        [:div
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          [:label.form-label
           "Year:"]
          (forms/select-raw
            (rum/cursor process-atom :closed-ycs/year)
            (concat
              [{:value 0 :text "- Select Year -"}]
              (->>
                current-year
                (inc)
                (range (- current-year 10))
                (reverse)
                (map (fn [y] {:value y :text (str y)})))))]]]]
      (buttons/button-web
        "Submit"
        {:on-click #(grid/dispatch-action app-atom :admin.closedycs/submit-dates {})
         :type :button
         :style :primary
         :size :default})]

     (when csv
       (list
         [:div
          {:class (u/bem :flex-grid-group [:flush-force :align-left :valign-middle])}
          [:div
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (headings/heading (str "Count: " counted-ycs) {:type :h2 :size :default :flush true})]]
          [:div
           {:class (u/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "Download as CSV"
              {:on-click
               #(grid/dispatch-action app-atom :admin.closedycs/button-download-csv {:csv csv})
               :type :button
               :style :secondary
               :size :small})]]]

         (datatables/table app-atom :admin.closedycs/table-closed-ycs {})
         (toaster/loading-overlay app-atom :admin.closedycs/list-closed-ycs)))]))

(defmethod t/transition-open :admin.closedycs [app-atom _ _]
  (presence/open app-atom {:context/ident :admin.closedycs}))

(defmethod t/transition-after-open :admin.closedycs [app-atom _ _]
  (datatables/initiate app-atom closed-ycs-table-config {}))

(defmethod flow/render-screen :admin.closedycs [app-atom _]
  (closed-ycs app-atom))